<input type="hidden" runat="server" value="-1" id="hdnCurrentLang" />
<input type="hidden" runat="server" value="-1" id="hdnViewChange" />
<div class="full-height i-parent-div" style="display: none">
  <div class="toolbar clearfix" style="position: fixed">
    <span class="Exiticn tooltip-ele" onclick="exitsurvey()" title="Exit Preview">
      <span></span>
    </span>
    <span style="margin-left: 5px; float: left; display: inline-block; zoom: 1">
      <span
        id="btnRestart"
        (click)="loadSurvey()"
        style="display: inline-block"
        class="Restrticn tooltip-ele"
        [title]="getRestartToolTip()"
      ></span>
    </span>
    <div id="previewMainStrip" class="devices-list">
      <span class="view-type">
        <span ID="web" (click)="loadViewPort('web')" class="view-icon view-web"></span>
      </span>
      <span class="view-type">
        <span ID="LinkButton1" class="view-icon view-seperator"></span>
      </span>
      <span class="view-type view-ipad">
        <span ID="tablet" (click)="loadViewPort('tablet')" class="view-icon view-ipad"></span>
      </span>
      <span class="view-type">
        <span class="view-icon view-seperator"></span>
      </span>
      <span class="view-type">
        <span ID="mobile" (click)="loadViewPort('mobile')" class="view-icon view-mobile"></span>
      </span>
    </div>
    <div class="action-options clearfix">
      <div class="preview-mode-msg-icon">
        <div class="preview-msg-tooltip" style="display: none">
          <div class="hdn-icn-div">
            <img class="hdn-icn-img" alt="hdn-icn" width="25px" height="25px" />
          </div>
          <div class="preview-tooltip-content">
            <div class="preview-text">
              <span [innerHTML]="strPreviewMsg | headerFooterHtml" id="spnPreviewMsg"></span>
            </div>
            <div class="estimated-time-text">
              Estimated completion time:
              <span
                class="estimated-time"
                [innerHTML]="strPreviewTime | headerFooterHtml"
                id="spnPreviewTime"
              ></span>
            </div>
            <div class="btn-wrapper clearfix">
              <input type="hidden" runat="server" value="0" id="hdnOkayGotIt" />
            </div>
          </div>
        </div>
      </div>
      <span class="view-settings">
        <a class="view-icon view-settings-icon tooltip-eleR" title="Settings"></a>
      </span>
      <span class="qrcode-icon">
        <a class="view-icon view-qr-icon tooltip-eleR" title="QR Code" (click)="GetQr()"></a>
      </span>

      <div class="pageno-settings">
        <div *ngIf="!pgNo" class="page-no-drop" id="dvPageNO">
          <span class="drop-arrow"></span>
          <select
            id="ddPreview"
            [(ngModel)]="selectedPage"
            (change)="SelectedValue($event)"
            aria-label="prvPage"
          >
            <option *ngFor="let pages of previewSettings?.previewPage" [value]="pages.page_no">
              <span [innerHTML]="'Page ' + pages.page_no | headerFooterHtml"></span>
              <span
                *ngIf="pages.PageName"
                [innerHTML]="' (' + pages.PageName + ')' | headerFooterHtml"
              ></span>
            </option>
            <option [innerHTML]="strThankyouText | headerFooterHtml" [value]="-1" selected></option>
          </select>
        </div>
      </div>
    </div>
    <div class="settings-menu">
      <div class="arrow-up"></div>
      <div class="content-item">
        <div class="content-val">
          Skip Mandatory/Encouraged
          <span
            class="more-info-parent skip-mandatory"
            tooltipStyleClass="hasIcon settingTooltipIcon"
            pTooltip="Choose to bypass Mandatory and Encouraged Response settings. Note: CAPTCHA will not be bypassed."
            tooltipPosition="bottom"
          ></span>
        </div>
        <div class="toggle-switch-btn">
          <span class="switch-handle"></span>
          <input type="radio" id="mandatoryCheck" runat="server" name="Skip Mandatory/Encouraged" />
          <span class="switch-check switch-no"></span>
        </div>
      </div>
      <div class="content-item">
        <div class="content-val">
          Show Hidden Questions<span
            class="more-info-parent show-hidden"
            tooltipStyleClass="hasIcon settingTooltipIcon"
            pTooltip="View questions otherwise hidden to participants, like pre- or post-populated hidden questions."
            tooltipPosition="bottom"
          ></span>
        </div>
        <div class="toggle-switch-btn">
          <span class="switch-handle"></span>
          <input type="radio" id="hiddnQCheck" runat="server" name="Show Hidden Question" />
          <span class="switch-check switch-no"></span>
        </div>
      </div>
      <div class="content-item">
        <div class="content-val">
          Bypass logic
          <span
            class="more-info-parent skip-logic"
            tooltipStyleClass="hasIcon settingTooltipIcon"
            pTooltip="View all content without Question Display Logic, Answer Display Logic or Branching applied."
            tooltipPosition="bottom"
          ></span>
        </div>
        <div class="toggle-switch-btn">
          <span class="switch-handle"></span>
          <input type="radio" id="CQCheck" runat="server" name="Skip Logic" />
          <span class="switch-check switch-no"></span>
        </div>
      </div>

      <div class="content-item participation-format-wrapper">
        <div class="content-val">
          Display Mode
          <span
            class="more-info-parent skip-logic"
            tooltipStyleClass="hasIcon settingTooltipIcon"
            pTooltip="Display questions to participants continuously (Classic) or one at a time (Focus)"
            tooltipPosition="bottom"
          ></span>
        </div>
        <div id="dvParticipationFormat" class="participation-drop-container">
          <span class="drop-arrow"></span>
          <select id="ddParticipationFormat" onchange="setSurveyFormat()" style="display: none">
            <option value="0">Classic</option>
            <option value="1">Compact</option>
            <option value="2">Comfortable</option>
          </select>
          <div class="surveyFormatDD" (click)="formListShow()">
            <span class="surveyFormatDDValue">
              <ng-container *ngIf="surveyFormat == 0"> Classic </ng-container>
              <ng-container *ngIf="surveyFormat == 1"> Compact </ng-container>
              <ng-container *ngIf="surveyFormat == 2"> Comfortable </ng-container>
            </span>
            <div class="surveyFormatDDList" id="formatList">
              <div class="surveyFormatDDListItem" (click)="setFormatSelect($event, '0')">
                Classic
              </div>
              <div class="surveyFormatDDListItem subListParent" style="position: relative">
                Focus
                <div class="surveyFormatDDList subList">
                  <div class="surveyFormatDDListItem" (click)="setFormatSelect($event, '1')">
                    Compact
                  </div>
                  <div class="surveyFormatDDListItem" (click)="setFormatSelect($event, '2')">
                    Comfortable
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Horizontal Preview-->
<div class="hrz-preview" style="display: none">
  <div class="preview-floating-options">
    <div class="responsive-option-wrapper">
      <span
        class="preview-container desktop-bg"
        ID="vr_web"
        title="Desktop"
        (click)="loadViewPort('web')"
      ></span>

      <span
        class="preview-container tablet-bg"
        title="Tablet"
        ID="vr_tablet"
        (click)="loadViewPort('tablet')"
      ></span>

      <span
        class="preview-container mobile-bg"
        title="Mobile"
        ID="vr_mobile"
        (click)="loadViewPort('mobile')"
      ></span>
    </div>
    <div class="hrz-preview-setting">
      <div id="settings-icon" class="settings-preview" title="Preview Settings"></div>
      <div id="hrz-preview-container">
        <div class="slideup-preview-container">
          <div class="content-item">
            <div class="content-val">
              Skip Mandatory/Encouraged
              <span
                class="more-info-parent skip-mandatory"
                tooltipStyleClass="hasIcon settingTooltipIcon"
                pTooltip="Choose to bypass Mandatory and Encouraged Response settings. Note: CAPTCHA will not be bypassed."
                tooltipPosition="bottom"
              ></span>
            </div>
            <div class="toggle-switch-btn">
              <span class="switch-handle"></span>
              <input
                type="radio"
                id="vr_mandatoryCheck"
                runat="server"
                name="Skip Mandatory/Encouraged"
              />
              <span class="switch-check switch-no"></span>
            </div>
          </div>
          <div class="content-item">
            <div class="content-val">
              Show Hidden Questions<span
                class="more-info-parent show-hidden"
                tooltipStyleClass="hasIcon settingTooltipIcon"
                pTooltip="View questions otherwise hidden to participants, like pre- or post-populated hidden questions."
                tooltipPosition="bottom"
              ></span>
            </div>
            <div class="toggle-switch-btn">
              <span class="switch-handle"></span>
              <input type="radio" id="vr_hiddnQCheck" runat="server" name="Show Hidden Question" />
              <span class="switch-check switch-no"></span>
            </div>
          </div>
          <div class="content-item">
            <div class="content-val">
              Bypass logic
              <span
                class="more-info-parent skip-logic"
                tooltipStyleClass="hasIcon settingTooltipIcon"
                pTooltip="View all content without Question Display Logic, Answer Display Logic or Branching applied."
                tooltipPosition="bottom"
              ></span>
            </div>
            <div class="toggle-switch-btn">
              <span class="switch-handle"></span>
              <input type="radio" id="vr_CQCheck" runat="server" name="Skip Logic" />
              <span class="switch-check switch-no"></span>
            </div>
          </div>

          <div class="content-item participation-format-wrapper">
            <div class="content-val">
              Display Mode
              <span
                class="more-info-parent skip-logic"
                tooltipStyleClass="hasIcon settingTooltipIcon"
                pTooltip="Display questions to participants continuously (Classic) or one at a time (Focus)"
                tooltipPosition="bottom"
              ></span>
            </div>
            <div id="dvParticipationFormat1" class="participation-drop-container">
              <span class="drop-arrow"></span>
              <select
                id="ddParticipationFormat1"
                onchange="setSurveyFormat()"
                style="display: none"
              >
                <option value="0">Classic</option>
                <option value="1">Compact</option>
                <option value="2">Comfortable</option>
              </select>
              <div class="surveyFormatDD" (click)="formListHrzShow()">
                <span class="surveyFormatDDValue">Classic</span>
                <div class="surveyFormatDDList" id="hrz-formatList">
                  <div class="surveyFormatDDListItem" (click)="setFormatSelect($event, '0')">
                    Classic
                  </div>
                  <div class="surveyFormatDDListItem subListParent" style="position: relative">
                    Focus
                    <div class="surveyFormatDDList subList">
                      <div class="surveyFormatDDListItem" (click)="setFormatSelect($event, '1')">
                        Compact
                      </div>
                      <div class="surveyFormatDDListItem" (click)="setFormatSelect($event, '2')">
                        Comfortable
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="new-window-wrapper" style="z-index: -1 !important">
      <div class="other-preview-option new-window" title="Open in new tab"></div>
    </div>
  </div>
</div>

<!-- Horizontal preview end -->
<div [hidden]="previewData.PrevPgNo !== 1">
  <div class="Plat_Alert Warning Plat_Alert_custom" style="display: none">
    <span class="success"></span>
    <span class="spnMsg"
      ><span [innerHTML]="strPreviewMsg | headerFooterHtml" id="spnPreviewMsgToast"></span
    ></span>
    <div class="estimated-time-text1">
      Estimated completion time:
      <span
        [innerHTML]="strPreviewTime | headerFooterHtml"
        class="estimated-time"
        id="spnPreviewTimeToast"
      ></span>
    </div>
    <span class="closebtn" id="close-btn"></span>
  </div>
</div>

<div id="deviceWrapper">
  <div id="previewViewport">
    <app-participation
      class="app-participation"
      [previewJsonData]="getPreviewData()"
    ></app-participation>
  </div>
</div>

<div class="qrcode-modal" style="display: none">
  <div>
    <span class="modal-heading">Your QR Code</span>
  </div>
  <div class="qrcode-img">
    <img id="img" src="{{ QRImagePath }}" alt="Alternate Text" />
  </div>
  <div class="qr-instruction">Scan this QR code to preview the survey on your own device.</div>
</div>
<div class="modal-overlay" style="display: none"><span class="close-modal"></span></div>
